<template>

  <div class="col-12 table-responsive">

    <table id="jt-table-lease" class="table table-bordered">

      <tr>
        
        <th 
          v-for="tableParameterItem in PARAM" 
          v-show="!tableParameterItem.hide"
          v-bind:key="tableParameterItem.key" >{{ tableParameterItem.text || tableParameterItem.key }}</th>

      </tr>

      <tr 
        v-for="(leaseDataItem, leaseDataIndex) in leaseData"
        v-bind:key="leaseDataItem.id" >

        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key"
          v-show="!tableParameterItem.hide" >

          <span v-if="tableParameterItem.key === 'index'">{{ leaseDataIndex + 1 }}</span>

          <div 
            v-else-if="tableParameterItem.key === 'status'"
            v-html="leaseDataItem['stopBillDate'] ? 'Stop Bill' : leaseDataItem[tableParameterItem.key]" />

          <div 
            v-else
            v-html="leaseDataItem[tableParameterItem.key]" />
          
        </td>

      </tr>

      <tr>

        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key"
          v-show="!tableParameterItem.hide" >{{ leaseTotal[tableParameterItem.key] }}</td>

      </tr>
        
    </table>

    <TemplateFeedback id="jt-feedback-lease" ref="leaseFeedback" class="mt-1"/>

  </div>

</template>

<script>
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import helper from "@/components/Utility/Helper"


const PARAM = [
  {
    key: 'index',
    text: '#',
  },
  {
    key: 'leaseZone',
    text: 'Zone Name'
  },
  {
    key: 'leaseProductName',
    text: 'Product Name'
  },
  {
    key: 'paymentPlanText',
    text: 'Payment Plan',
  },
  {
    key: 'commencementDateText',
    text: 'Commencement Date',
  },
  {
    key: 'leaseProductDepositText',
    text: 'Deposit (RM)',
  },
  {
    key: 'leaseProductEstbFeeText',
    text: 'Estb. Fee (RM)',
  },
  {
    key: 'leaseProductInitialParkingFeeText',
    text: 'Initial Parking Fee (RM)',
  },
  {
    key: 'leaseProductInitialPaymentText',
    text: 'Initial Payment (RM)',
  },
  {
    key: 'leaseProductParkingFeeText',
    text: 'Parking Fee (RM)',
  },
  {
    key: 'leaseParkerInformation',
    text: 'Parker Information',
  },
  {
    key: '_isParkAide',
    text: 'Enable ParkAide',
  },
  {
    key: 'status',
    text: 'Status',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['stopBillDate']) {
        return 'Stop Bill';
      }
      return dataItem['status']
    },
  },
  // {
  //   key: 'passcardText',
  //   text: 'Passcard',
  // },
];

export default {
  name: "PagePLViewLease",
  props: ['tableParameter'],
  components: {
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
      ],

      PARAM,

      leaseData: [{}],
      leaseTotal: {},

      PRODUCT_PARAMS: ['leaseProductDeposit', 'leaseProductEstbFee', 'leaseProductInitialParkingFee', 'leaseProductInitialPayment', 'leaseProductParkingFee'],
      PARKER_PARAMS: ['leaseParkerInformation', 'leaseParkerName', 'leaseParkerMobile', 'leaseParkerPlate', 'leaseParkerEmail'],
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
  },
  methods: {
    setLeaseData(leaseData, leaseEnableEdit) {
      this.leaseData = leaseData || [];
      this.leaseEnableEdit = leaseEnableEdit;
    },
    setLeaseTotal(leaseTotal) {
      leaseTotal = leaseTotal || {};
      this.PRODUCT_PARAMS.forEach(k => {
        leaseTotal[k + 'Text'] = leaseTotal[k + 'Text'] || helper.formatMoney(leaseTotal[k]);
      });
      leaseTotal['commencementDateText'] = 'Total (RM)';
      this.leaseTotal = leaseTotal;
    },

    setLeaseDataSeason(data, season) {
      if(!season) {
        data['seasonID'] = null;
        this.removeLeaseDataSeasonField(data);
      }
    },
    setLeaseDataParker(data, parker) {
      if(!parker) {
        data['parkerID'] = null;
        this.removeLeaseDataParkerField(data);
      } else {
        data['leaseParkerInformation'] = helper.plFormParker(parker);
      }
      
      if(data['passcardText']) {
        data['leaseParkerInformation'] += '<br>Passcard: ' + data['passcardText'];
      }
      this.$forceUpdate();
    },

    removeLeaseDataSeasonField(data) {
      this.PRODUCT_PARAMS.forEach(k => {
        data[k] = null;
        data[k + 'Text'] = null;
      })
    },
    removeLeaseDataParkerField(data) {
      this.PARKER_PARAMS.forEach(k => {
        data[k] = null;
      })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLViewLease.vue